<template>
  <div :class="classnames">
    <template v-if="isOpen">
      <interactive-svg-icon :active="isOpen">
        <svg-icon-caret-up height="6" width="12" />
      </interactive-svg-icon>
    </template>

    <template v-else>
      <interactive-svg-icon :active="isOpen">
        <svg-icon-caret-down height="6" width="12" />
      </interactive-svg-icon>
    </template>
  </div>
</template>

<script>
  import InteractiveSvgIcon from '@/components/InteractiveSvgIcon'
  import SvgIconCaretDown from '@/svgs/SvgIconCaretDown'
  import SvgIconCaretUp from '@/svgs/SvgIconCaretUp'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'drawer-button'

  const modifiers = {
    isOpen: 'is-open'
  }

  export default {
    name: 'DrawerButton',
    components: {
      'interactive-svg-icon': InteractiveSvgIcon,
      'svg-icon-caret-down': SvgIconCaretDown,
      'svg-icon-caret-up': SvgIconCaretUp
    },
    mixins: [ bem ],
    props: {
      isOpen: {
        type: Boolean
      }
    },
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const isOpen = this.isOpen && modifiers.isOpen

        return [ isOpen ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Drawer/DrawerButton.vue